import { render } from "./SVGColorFloor.vue?vue&type=template&id=2e7908f0"
import script from "./SVGColorFloor.vue?vue&type=script&lang=js"
export * from "./SVGColorFloor.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__